<template>
  <div :style="charts18Style" class="tjpl">
    <div id="echarts18" :style="charts18Style"></div>
    <div class="sumtask">
      停机总时长:
      <span>{{stime}}次</span>
    </div>
    <div class="tab-switch">
      <span
        v-for="item in tabData"
        :class="[{'current': tabKey==item}]"
        v-text="item"
        :key="item"
        @click="tabSwitch(item);dataChang(item)"
      ></span>
    </div>
  </div>
</template>
<script>
export default {
  name: "echarts18",
  props: {
    charts18Style: {
      type: Object,
      default: () => {
        return { width: "100%", height: "184px", position: "relative" };
      }
    },
    echarts18Data: {
      type: Array,
      default: () => {
        return [
          { name: "接近时间", value: 5 },
          { name: "诊断时间", value: 3 },
          { name: "更换或修理时间", value: 8 },
          { name: "验证时间", value: 4.5 },
          { name: "校准时间", value: 2.5 }
        ];
      }
    },
    stime: {
      type: String,
      default: () => {
        return "16";
      }
    }
  },
  data() {
    let tabData = ["日", "周", "月"];
    let endTime = new Date(
      new Date(new Date().toLocaleDateString()).getTime() +
        24 * 60 * 60 * 1000 -
        1
    );
    return {
      tabData: tabData,
      tabKey: tabData[0],
      settime: endTime
    };
  },
  mounted() {
    this.pies();
  },
  methods: {
    tabSwitch(item) {
      // console.log(item);
      this.tabKey = item;
      //   this.getGzsjhzList();
    },
    dataChang(val) {
      this.$emit("receiveData", val);
    },
    pies() {
      var _this = this;
      var behaviorpie = this.$echarts.init(
        document.getElementById("echarts18")
      );
      let option = {
        color: ["#1D4C6A", "#2D73A4", "#3FA3E1", "#6AC6F5", "#B7EFFF"],
        title: {
          text: "停机频率分析",
          left: 20,
          top: 0,
          textStyle: {
            color: "#0BECF7",
            fontSize: 18
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          top: "middle",
          right: 10,
          top: 65,
          textStyle: {
            color: "#000",
            fontSize: 12
          },
          itemWidth: 12, // 图例图形宽度
          itemHeight: 12, // 图例图形高度
          data: _this.echarts18Data,
          formatter: function(data) {
            // console.log(data);
            for (let index = 0; index < _this.echarts18Data.length; index++) {
              if (_this.echarts18Data[index].name == data) {
                return (
                  _this.echarts18Data[index].value + "次" + " " + " " + data
                );
              }
            }
          }
        },
        series: [
          {
            name: "停机频率分析",
            type: "pie",
            radius: "70%",
            center: ["24%", "55%"],
            label: {
              show: false,
              formatter: "{b}: {d}%"
            },
            data: _this.echarts18Data,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      };
      behaviorpie.setOption(option);
    }
  }
};
</script>
<style scoped>
.tjpl{
  margin-top: 35px;
}
.sumtask {
  width: 130px;
  height: 28px;
  position: absolute;
  top: 30px;
  right: 2px;
  font-size: 12px;
  line-height: 28px;
  background-color: #9F8646;
  color: #fff;
  text-align: left;
  padding-left: 10px;
}
.sumtask span {
  color: #fff;
  font-size: 16px;
}
.tab-switch {
  width: 148px;
  height: 30px;
  position: absolute;
  right: -20px;
  top: -20px;
}
.tab-switch span {
  color: #fff;
  font-size: 12px;
  text-align: center;
  width: 26px;
  padding: 3px;
  margin: 0px 6px;
  line-height: 18px;
  height: 18px;
  display: inline-block;
  background-color: #84A89C;
  border-radius: 5px;
}
.current {
  background: #07AFA0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/xiayan/home/home/echarts9.vue